import React from 'react';

interface EditorHeaderProps {
  moduleName: string;
  sectionCount: number;
  isSaving: boolean;
  onClose: () => void;
}

const EditorHeader: React.FC<EditorHeaderProps> = ({
  moduleName,
  sectionCount,
  isSaving,
  onClose
}) => {
  return (
    <div className="flex items-center justify-between px-6 py-4 border-b border-gray-200 bg-white">
      <div className="flex items-center">
        <h2 className="text-xl font-semibold text-gray-900">
          Chỉnh sửa cấu trúc: {moduleName}
        </h2>
        <span className="ml-3 text-sm text-gray-500">
          ({sectionCount} sections)
        </span>
      </div>
      <div className="flex items-center">
        <button
          onClick={onClose}
          disabled={isSaving}
          className="bg-gray-200 hover:bg-gray-300 text-gray-700 p-2 rounded-lg font-medium transition-colors"
          aria-label="Đóng"
        >
          <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default EditorHeader; 